var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaceholderLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 333 323",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M75.0796 322.018L0.976562 283.842V116.889L167.851 0L332.535 116.889V283.842L258.765 322.018L174.605 276.379L246.816 234.298L258.765 238.974V158.97L167.851 85.7197L72.2618 158.97V238.974L84.73 234.298L156.422 276.379L75.0796 322.018Z",
  fill: "#E6E6E6"
})));
export default SvgPlaceholderLogo;